import {useClinicianStyles} from './useClinicianStyles';
import {useTranslation} from 'react-i18next';
import moment from 'moment/moment';
import _ from 'lodash';
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import {Button, Fade, List, ListItem, ListItemButton, Tooltip, Typography} from '@mui/material';
import clsx from 'clsx';
import Grid from '@mui/material/Grid';
import {isMobile} from 'react-device-detect';
import React from 'react';
import IsolatedMenu from './isolatedMenu';
import {getConfig} from '../../../util/configUtil';

const MedicalNurseNotes = ({
                               notes,
                               setNotes,
                               setFormIsModified,
                               user,
                               setAddBtnSeen,
                               setInitialNote,
                               handleConfirm,
                           }) => {
    const classes = useClinicianStyles();
    const {t} = useTranslation();

    const userName = `${user?.firstName} ${user?.familyName}`;
    const grid = 8;
    const notesCount = notes.length;

    // Config
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');

    const deleteNote = note => {
        setNotes(notes.filter(n => n.id !== note.id));
        setFormIsModified(true);
    };

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = result => {
        if (!result.destination) {
            return;
        }

        const items = reorder(notes, result.source.index, result.destination.index);

        setNotes(items);
        setFormIsModified(true);
    };

    const getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: 'none',

        ...draggableStyle,
    });

    const getListStyle = (isDraggingOver) => ({
        height: `${notesCount * 51 + grid}px`,
        width: '100%',
    });

    const checkNote = note => {
        const tempNote = {
            ...note, checked: !note.checked, timestamp: moment(), checkedBy: userName,
        };
        if (!tempNote.checked) {
            handleConfirm(tempNote);
        } else {
            let notesTemp = notes.map(n => n.id === note.id ? tempNote : n);
            notesTemp = _.sortBy(notesTemp, ['checked']);
            setNotes(notesTemp);
            setFormIsModified(true);
        }
    };

    const editNote = localNote => {
        setAddBtnSeen(true);
        setInitialNote(localNote);
        setNotes(prev => prev.filter(n => n.id !== localNote.id));
        setFormIsModified(true);
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <List
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        {notes && notes.map((note, index) => (
                            <Draggable key={note.id} draggableId={note.id} index={index}>
                                {(provided, snapshot) => (
                                    <ListItem
                                        disablePadding
                                        key={note.id}
                                        className={classes.listItem}
                                        style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    >
                                        <ListItemButton className={classes.noteItem}>
                                            <div className={classes.noteItem}>
                                                <span className={classes.indexNumber}>
                                                    {index + 1}
                                                </span>

                                                <Tooltip
                                                    title={note.text}
                                                    TransitionComponent={Fade}
                                                    TransitionProps={{timeout: 600}}
                                                    style={{minWidth: '105px'}}
                                                >
                                                    <span className={classes.noteText}>
                                                        {note.text.slice(0, 30)}
                                                    </span>
                                                </Tooltip>
                                            </div>
                                        </ListItemButton>

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className={clsx(classes.checkBtn, note.checked && classes.checked)}
                                            style={{marginRight: '5px'}}
                                            onClick={() => checkNote(note)}
                                        >
                                            {note.checked ? (
                                                <Grid container xs={12} flexDirection="column">
                                                    <div
                                                        className={clsx(classes.checkedBy, isMobile && 'mobile')}
                                                    >
                                                        {note.checkedBy}
                                                    </div>
                                                    <div
                                                        className={clsx(classes.checkedByTimestampText, isMobile && 'mobile')}
                                                    >
                                                        {moment(note.timestamp).format(defaultDateTimeFormat)}
                                                    </div>
                                                </Grid>
                                            ) : (
                                                <Typography
                                                    variant="body2"
                                                    className={clsx(classes.notCompletedTimestampText, isMobile && 'mobile')}
                                                >
                                                    {t('NOT COMPLETED')}
                                                </Typography>
                                            )}
                                        </Button>

                                        <IsolatedMenu
                                            id={note.id}
                                            note={note}
                                            user={user}
                                            deleteNote={deleteNote}
                                            editNote={editNote}
                                        />
                                    </ListItem>
                                )}
                            </Draggable>
                        ))}
                    </List>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default MedicalNurseNotes;